import {computed, reactive} from "vue";

export default function usePagination(
    dataStore,
    initialPerPage = 15,
    useServer = false,
) {
    const meta = reactive({
        perPage: initialPerPage,
        offset: 0,
        currentPage: 0,
        hasMoreData: false,
        total: null,
        params: {},
        useServer,
    })

    const loading = computed(() => (dataStore.loading));

    const dataSize = computed(() => (dataStore.items?.length || 0));

    const perPage = computed(() => (meta.perPage));

    const currentPage = computed(() => (meta.currentPage));

    const hasMoreData = computed(() => (meta.hasMoreData));

    const total = computed(() => (meta.total));

    const pageData = computed(() => {
        const startIndex = meta.currentPage * meta.perPage;
        let endIndex = startIndex + meta.perPage;
        const len = dataSize.value;
        if (endIndex > len) {
            endIndex = len;
        }
        const arr = (dataStore.items || []);
        console.log('page data', startIndex, endIndex, arr.length);
        return arr.slice(startIndex, endIndex);
    });

    const fullData = computed(() => {
        return dataStore.items || [];
    })

    const countPages = computed(() => {
        const len = meta.total || dataSize.value;
        return Math.ceil(len / meta.perPage);
    });

    function _resetPagination() {
        meta.offset = 0;
        meta.hasMoreData = !!meta.useServer;
        meta.currentPage = 0;
        meta.total = null;
        meta.params = {}
        dataStore.resetData();
    }


    function _setParams(newParams) {
        const newParamsInstance = JSON.parse(JSON.stringify(newParams));
        const oldParamsInstance = JSON.parse(JSON.stringify(meta.params))
        if (useServer) {
            newParamsInstance.page = 0;
            oldParamsInstance.page = 0;
        }
        const strParams = JSON.stringify(newParamsInstance);
        const oldParams = JSON.stringify(oldParamsInstance);
        if (strParams !== oldParams) {
            _resetPagination();
            meta.params = newParamsInstance;
            return;
        }
        meta.params = newParams;
    }

    function _setNextParams(params) {
        const newParams = JSON.parse(JSON.stringify(meta.params));
        if (params) {
            for (let key in params) {
                newParams[key] = params[key];
            }
        }
        if (meta.useServer) {
            newParams.per_page = meta.perPage;
            newParams.page = meta.currentPage + 1;
        }
        _setParams(newParams);
    }

    function _calcPagination(loadedCount) {
        const total = meta.total || 0;

        meta.hasMoreData = (total) ? dataSize.value < total  :  (loadedCount >= meta.perPage);
        console.log('hasMore', meta.hasMoreData, dataSize.value, loadedCount,  total );
        if (dataSize.value > 0) {
            meta.offset = Math.ceil(dataSize.value / meta.perPage);
            console.log('new offset', meta.offset, dataSize.value, meta.perPage  );
        }
        if (dataStore.total !== null && dataStore.total !== undefined) {
            meta.total = dataStore.total;
        }
    }

    function _setCurrentPage(newPage) {
        console.log('set new page', newPage, meta.offset)
        if (newPage < 0) {
            console.log('newPage < 0');
            meta.currentPage = 0;
        } else if (newPage >= meta.offset) {
            console.log('newPage >= meta.offset', newPage, meta.offset);
            meta.currentPage = meta.offset - 1 ;
        } else {
            console.log('else');
            meta.currentPage = newPage;
        }
        if (meta.currentPage < 0) meta.currentPage = 0;
        console.log('result page', meta.currentPage);
    }

    async function _loadNext(params = null) {
        console.log('_loadNext', JSON.stringify(params));
        if (!params) {
            params = meta.params;
        }
        _setNextParams(params);
        const oldSize = dataSize.value;
        await dataStore.loadData(meta.params);
        _calcPagination(dataSize.value - oldSize);
    }

    function isActualPage(page) {
        return (page <= meta.offset);
    }

    async function setPage(newPage) {
        if (loading.value) throw 'wait loading operation';
        console.log('setPage', newPage, meta.offset, meta.hasMoreData);
        if ((newPage >= meta.offset) && meta.hasMoreData) {
            await _loadNext();
        }
        _setCurrentPage(Number.parseInt(newPage));
    }

    async function decPage() {
        await setPage(meta.currentPage - 1);
    }

    async function incPage() {
        await setPage(meta.currentPage + 1);
    }

    async function firstPage() {
        await setPage(0);
    }

    async function lastPage() {
        console.log('last page', countPages.value)
        await setPage(countPages.value);
    }

    async function setPerPage(newPerPage) {
        meta.perPage = Number.parseInt(newPerPage);
        await _loadNext();
    }


    async function initLoad(params) {
        dataStore.clearData();
        _resetPagination();
        const pageParams = meta.useServer ? {per_page: meta.perPage, page: 0} : {};
        await _loadNext({...(params || {}), ...pageParams});
    }

    return {
        perPage,
        currentPage,
        hasMoreData,
        total,
        dataSize,
        pageData,
        fullData,
        countPages,
        loading,
        isActualPage,
        setPage,

        decPage,
        incPage,
        lastPage,
        firstPage,

        setPerPage,
        initLoad,
    };
}
